<template>
  <div>
    <app-cells>
      <h1 class="title">Dictionaries</h1>
    </app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view  />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'DictionariesLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [ { name: 'locations', label: 'Locations' } ],
    }
  },
}
</script>
